export default __webpack_public_path__ + "static/media/Akshay_Kumar_Resume_v2.85f95e9f.pdf";